import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPackage = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M5.36523 4.36331C5.58398 3.92581 6.04883 3.62503 6.54102 3.62503H9.68555V7.12503H3.99805L5.36523 4.36331ZM10.5605 7.12503V3.62503H13.6777C14.1699 3.62503 14.6348 3.92581 14.8535 4.36331L16.248 7.12503H10.5605ZM16.248 8.00003V14.125C16.248 15.1094 15.4551 15.875 14.498 15.875H5.74805C4.76367 15.875 3.99805 15.1094 3.99805 14.125V8.00003H16.248Z"
	})
});
const ForwardRef = forwardRef(SvgPackage);
export default ForwardRef;
